function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Button, Input, Alert, Divider } from "antd";
import { UnlockFilled } from "@ant-design/icons";
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var UserLogin = function UserLogin() {
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formLoading = _useState2[0],
    setFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormError = _useState4[0],
    setIsFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    user = _useState8[0],
    setUser = _useState8[1];
  var onFinish = function onFinish(values) {
    setFormLoading(true);
    setIsFormError(false);
    var formData = new FormData();
    formData.append('mobile', values.mobile);
    formData.append('password', values.password);
    axios.post(Common.baseApiUrl + 'login', formData).then(function (result) {
      setFormLoading(false);
      var data = result['data'];
      if (data.status == 200) {
        var usr = data.user;
        setUser(usr);
        setUserData(usr);
        if (usr.role == 11) navigate('/home/cashier');
        if (usr.role == 21) navigate('/home/consultations');
        if (usr.role == 22) navigate('/home/consultations');
        if (usr.role == 23) navigate('/home/consultations');
        if (usr.role == 24) navigate('/home/consultations');
        if (usr.role == 31) navigate('/home/laboratoire');
        if (usr.role == 41) navigate('/home/pharmacie');
        if (usr.role == 51) navigate('/home/chirurgie');
        if (usr.role == 61) navigate('/home/laser');
        if (usr.role == 71) navigate('/home/facturation');
        if (usr.role == 81) navigate('/home');
        if (usr.role == 101) navigate('/home');
        if (usr.role == 91) navigate('/home');
        if (usr.role == 2) navigate('/company/' + usr.company_id.toString());
        if (usr.role == 13) navigate('/insurance/' + usr.insurance_id.toString());
        if (usr.role == 201) navigate('/home/consumables');
        window.location.reload();
      } else {
        setErrorMessage(data['message']);
        setIsFormError(true);
      }
    });
  };
  var setUserData = function setUserData(u) {
    localStorage.clear();
    localStorage.setItem('userData', JSON.stringify(u));
    localStorage.setItem('isOn', true);
    return;
  };
  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        fontSize: '17px'
      },
      children: [/*#__PURE__*/_jsx(UnlockFilled, {}), " ", /*#__PURE__*/_jsx("b", {
        children: "HospiManager"
      }), ", veuillez entrer vos identifiant pour acceder \xE0 votre compte"]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      name: "ulogin",
      size: "large",
      layout: "vertical",
      initialValues: {
        remember: true
      },
      requiredMark: false,
      onFinish: onFinish,
      onFinishFailed: onFinishFailed,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "Num\xE9ro mobile",
        name: "mobile",
        rules: [{
          required: true,
          message: 'Veuillez entrer un numéro de téléphone'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez votre identifiant ici"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Mot de passe",
        name: "password",
        rules: [{
          required: true,
          message: 'Le mot de passe est obligatoire !'
        }],
        children: /*#__PURE__*/_jsx(Input.Password, {
          placeholder: "Entrer votre mot de passe"
        })
      }), isFormError ? /*#__PURE__*/_jsx(Alert, {
        style: {
          marging: '5px 0px',
          fontSize: '14px'
        },
        message: errorMessage,
        type: "error",
        showIcon: true
      }) : /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: formLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "SE CONNECTER"
          })
        })
      })]
    })]
  });
};
export default UserLogin;